import React from "react";

const Developer = () => {
  return (
    <section className="py-10 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* Heading */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[#090C6A]">
            About Siddha Group
          </h2>
          <div className="w-24 h-1 bg-[#090C6A] mx-auto mt-3 rounded"></div>
        </div>

        <p className="text-gray-700 leading-relaxed">
          Since its inception in 1986, Siddha has been crafting residential and
          commercial spaces with a difference, to make good living affordable in
          3 cities across India, namely Kolkata, Mumbai and Jaipur . Under the
          leadership of Group Chairman Shri Chandra Prakash Jain and Group
          Managing Director Shri Sanjay Jain, Siddha has won 30+ prestigious
          awards over the years. They have been the pioneers of Rooftop Skywalks
          in India.
        </p>
      </div>
    </section>
  );
};

export default Developer;
